const euro2008Questions = [
  {
    text: (
      <span style={{ fontSize: '14px', textAlign: 'justify' }}>
        Euro 2008'deki Türkiye'nin performansı hakkında bilginizi test edin! <br/> <br/>Sorular yapay zeka tarafından üretilmiştir. Cevaplarınız kaydedilmemektedir.
      </span>
    ),
    options: [
      {
        text: '9 soruluk teste ulaşmak için tıklayınız.',
        weight: 1,
      },
    ],
  },
  {
    text: 'Türkiye, Euro 2008’de hangi aşamaya kadar yükseldi?',
    options: [
      {
        text: 'Grup aşaması',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'Çeyrek final',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'Yarı final',
        character: 'Doğru',
        weight: 1,
      },
      {
        text: 'Final',
        character: 'Yanlış',
        weight: 1,
      },
    ],
  },
  {
    text: 'Türkiye’nin Euro 2008’deki unutulmaz İsviçre maçını hangi oyuncu son dakika golüyle kazandırdı?',
    options: [
      {
        text: 'Nihat Kahveci',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'Tuncay Şanlı',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'Semih Şentürk',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'Arda Turan',
        character: 'Doğru',
        weight: 1,
      },
    ],
  },
  {
    text: 'Euro 2008’de Türkiye, Hırvatistan’a karşı penaltılarla galip geldi. Hangi Türk oyuncu bu maçta eşitlik golünü attı?',
    options: [
      {
        text: 'Mehmet Topal',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'Semih Şentürk',
        character: 'Doğru',
        weight: 1,
      },
      {
        text: 'Gökhan Zan',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'Tuncay Şanlı',
        character: 'Yanlış',
        weight: 1,
      },
    ],
  },
  {
    text: 'Euro 2008’de Türkiye’nin gol krallığına kim ulaştı?',
    options: [
      {
        text: 'Nihat Kahveci',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'Arda Turan',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'Semih Şentürk',
        character: 'Doğru',
        weight: 1,
      },
      {
        text: 'Emre Belözoğlu',
        character: 'Yanlış',
        weight: 1,
      },
    ],
  },
  {
    text: 'Türkiye, Euro 2008 yarı finalinde hangi ülkeye elendi?',
    options: [
      {
        text: 'Almanya',
        character: 'Doğru',
        weight: 1,
      },
      {
        text: 'İspanya',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'İtalya',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'Portekiz',
        character: 'Yanlış',
        weight: 1,
      },
    ],
  },
  {
    text: 'Euro 2008’de hangi Türk oyuncu Almanya’ya karşı oynanan yarı final maçında muhteşem ilk golü attı?',
    options: [
      {
        text: 'Tuncay Şanlı',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'Nihat Kahveci',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'Uğur Boral',
        character: 'Doğru',
        weight: 1,
      },
      {
        text: 'Hamit Altıntop',
        character: 'Yanlış',
        weight: 1,
      },
    ],
  },
  {
    text: 'Türkiye, grup aşamasında kaç galibiyet aldı?',
    options: [
      {
        text: '1',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: '2',
        character: 'Doğru',
        weight: 1,
      },
      {
        text: '3',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'Hiç galibiyet almadı',
        character: 'Yanlış',
        weight: 1,
      },
    ],
  },
  {
    text: 'Euro 2008’de Türk Milli Takımı’nın teknik direktörü kimdi?',
    options: [
      {
        text: 'Fatih Terim',
        character: 'Doğru',
        weight: 1,
      },
      {
        text: 'Şenol Güneş',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'Mustafa Denizli',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'Ersun Yanal',
        character: 'Yanlış',
        weight: 1,
      },
    ],
  },
  {
    text: 'Euro 2008’de Türkiye, grup aşamasında hangi ülkeyi 3-2 yenerek çeyrek finale yükseldi?',
    options: [
      {
        text: 'Portekiz',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'İsviçre',
        character: 'Yanlış',
        weight: 1,
      },
      {
        text: 'Çek Cumhuriyeti',
        character: 'Doğru',
        weight: 1,
      },
      {
        text: 'Avusturya',
        character: 'Yanlış',
        weight: 1,
      },
    ],
  },
];

export default euro2008Questions;
